import { render, staticRenderFns } from "./ViewInvoicesView.vue?vue&type=template&id=54e6f2b2&scoped=true"
import script from "./ViewInvoicesView.vue?vue&type=script&lang=js"
export * from "./ViewInvoicesView.vue?vue&type=script&lang=js"
import style0 from "./ViewInvoicesView.vue?vue&type=style&index=0&id=54e6f2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e6f2b2",
  null
  
)

export default component.exports